module.exports = __webpack_public_path__ + "static/media/logo-FOOTER.a160c64c.png";